import React from 'react';
import NavBar from '@/components/NavBar';
import { StripeConfigurationPanel } from '@/components/StripeConfigurationPanel';
import FeatureFlagsPanel from '@/components/FeatureFlagsPanel';
import MFAEnroll from '@/components/MFAEnroll';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Settings, ArrowLeft, BarChart3 } from 'lucide-react';
import { Link, Navigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { useUserRole } from '@/hooks/useUserRole';
import SEOHead from '@/components/SEOHead';

const Configuration = () => {
  const { isAdmin, loading } = useUserRole();

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-purple-50">
        <NavBar />
        <div className="container mx-auto px-4 py-8">
          <div className="max-w-2xl mx-auto text-center">
            <div className="animate-pulse">Verificando permisos...</div>
          </div>
        </div>
      </div>
    );
  }

  if (!isAdmin) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-purple-50">
      <SEOHead 
        title="Configuración del Sistema - CompresorJPEG"
        description="Panel de administración para configurar integraciones, servicios y opciones avanzadas del compresor de imágenes."
        canonical="https://compresorjpeg.com/configuration"
        noindex={true}
      />
      <NavBar />
      
      <div className="container mx-auto px-4 py-8">
        <div className="max-w-2xl mx-auto">
          {/* Header */}
          <div className="flex items-center gap-4 mb-8">
            <Link to="/">
              <Button variant="ghost" size="sm">
                <ArrowLeft className="h-4 w-4 mr-2" />
                Volver
              </Button>
            </Link>
            <div>
              <h1 className="text-3xl font-bold text-gray-800 flex items-center gap-2">
                <Settings className="h-8 w-8 text-blue-600" />
                Configuración del Sistema
              </h1>
              <p className="text-gray-600 mt-2">
                Panel de administración para configurar integraciones y servicios
              </p>
            </div>
          </div>

          {/* Configuration Panels */}
          <div className="space-y-6">
            <MFAEnroll />
            <FeatureFlagsPanel />
            <StripeConfigurationPanel />

            {/* Analytics link */}
            <Link to="/analytics">
              <Card className="hover:shadow-md transition-shadow cursor-pointer">
                <CardHeader>
                  <CardTitle className="flex items-center gap-2">
                    <BarChart3 className="h-5 w-5 text-purple-600" />
                    Analytics de Conversión
                  </CardTitle>
                  <CardDescription>
                    Visualiza el embudo de conversión, tráfico y comportamiento de usuarios
                  </CardDescription>
                </CardHeader>
              </Card>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Configuration;